import React,{useState} from "react";
import { DashboardLayout, FormParser,PopupModal } from "../Components";
import { NavLink } from "react-router-dom";
import Masters from "../Components/masters.json"
import "./Pages.css"
import axiosConfig from "../Service/axiosConfig"

const AppointmentsAdd = () => {
    const[CustomError,SetCustomError]=useState("")
    const[CustomError1,SetCustomError1]=useState("")
    const[Error,SetError]=useState("")
    const [popupType, setpopupType] = useState("");

    const MastersModal=Masters.MyAppointments
    const formSubmit=(Data)=>{
        console.log(Data)
        axiosConfig.post("/clinics/Scheduler/",Data).then(res=>{
                   console.log(res)
                   setpopupType("success")
        }).catch(error=>{
            console.log(error.response.data)
            const ErrorData=[]
            ErrorData.push({
                code:error.response.data.code||["null"],
                name:error.response.data.name||["null"],
                    })
                    console.log(ErrorData[0])
            if(ErrorData[0].code[0]==="This field must be unique."){
                SetError(" code already exists.")
            }
            if(ErrorData[0].name[0]==="This field must be unique."){
                SetError("Title already Exists")
            }
            setpopupType("error")
        })
      }
    return (
        <>
            <DashboardLayout>
                <div className="dashboard-header">
                    <h5 className="dashboard-subtitle">Add Appointment</h5>
                    <NavLink to="/dashboard/qms/appointments" ><button className="btn btn-white">Manage</button></NavLink>
                </div>
                <FormParser modelObject={MastersModal} formSubmit={formSubmit} error={Error}/>
                {popupType != "" &&
                    <PopupModal popupType={popupType} Navigation="/dashboard/qms/appointments"/>
                }
            </DashboardLayout>
        </>
    )

}
export {AppointmentsAdd}